import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_job_status = _resolveComponent("job-status")!

  return (_openBlock(), _createBlock(_component_job_status, {
    "job-id": _ctx.postImport.jobId,
    modelValue: _ctx.jobRun,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobRun) = $event)),
    style: {"font-size":"1.25rem"}
  }, {
    default: _withCtx(({ isPending, isRunning, success, failure }) => [
      (isPending || isRunning)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "fa fa-spinner fa-spin"
          }))
        : failure
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 1,
              name: "fa fa-exclamation-circle",
              color: "negative",
              title: "Import failed."
            }))
          : success
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 2,
                name: "fa fa-check-circle",
                color: "green-4"
              }))
            : (_openBlock(), _createBlock(_component_q_icon, {
                key: 3,
                name: "fa fa-spinner fa-spin"
              }))
    ]),
    _: 1
  }, 8, ["job-id", "modelValue"]))
}